export default "### 2022-04-06 - Portal v4.2.1 Hotfix  \n---\n\nBugs Fixed  \n-   Improved backward compatibility for old clients\n"